import Api from "../../api/Api";
import { toast } from "react-toastify";
import axios from "axios";
import {
  ADD_IDS_FAIL,
  ADD_IDS_SUCCESS,
  DELETE_IDS_SUCCESS,
  GET_IDS,
  GET_IDS_SUCCESS,
  UPDATE_IDS_SUCCESS,
} from "./actionTypes";

export const loadEmails = () => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.get("/emails/get");

  toast.promise(req, {
    pending: "Getting Emails...",
    success: {
      render({ data }) {
        dispatch({
          payload: { emails: data.data.data },
          type: GET_IDS_SUCCESS,
        });
        return "Your Data Is Ready";
      },
    },
    error: {
      render({ data }) {
        return "An error occurred while getting Emails";
      },
    },
  });
};

export const updateEmail = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/emails/update", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_IDS_SUCCESS,
        });
        return "Email updated successfully";
      },
    },
    error: {
      render({ data }) {
        console.log(data);
        return "An error occurred while updating your Email";
      },
    },
  });
};

export const deleteEmails = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  let req = Api.post("/emails/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: DELETE_IDS_SUCCESS,
        });
        return "Email deleted successfully";
      },
    },
    error: {
      render({ data }) {
        console.log(data);
        return "An error occurred while deleting your Email";
      },
    },
  });
};

export const exportEmails = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  // Api.defaults.headers.common["Content-Type"] = "multipart/form-data";
  let req = Api.post("/emails/export", {
    month: data.formData.month,
    year: data.formData.year,
  });

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render(response) {
        // dispatch(loadEmails());

        window.open(response.data.data, "_blank");
        return "Emails exported successfully";
      },
    },
    error: {
      render(err) {
        return err?.data.response.data.error;
      },
    },
  });
};
